<template>
    <div class="login aside-theme">
        <div class="content" :style="{ backgroundImage: 'url(' + lambda.bg + ')' }">
            <div class="title">
                <h2>{{ title }}</h2>
                <p>{{ subtitle }}</p>
            </div>
        </div>
        <div class="auth">
            <div class="lang-switcher" v-if="lambda.has_language && languages.length >= 2">
                <a v-for="item in languages" :key="item.index"
                   :class="selectedLang === item.code ? 'active' : ''" href="javascript:void(0)"
                   @click="switchLanguage(item.code)">
                    {{ item.label }}
                </a>
            </div>

            <div class="form-wrap">
                <router-view :selectedLang="selectedLang"></router-view>
                <div class="copyright" v-html="copyright"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "microcredit",
        data() {
            return {
                loading: false,
                isSuccess: false,
                isError: false,
                credentials: {
                    login: null,
                    password: null
                },
                selectedLang: localStorage.getItem("lang") == null ? window.lambda.default_language : localStorage.getItem("lang"),
                languages:window.lambda.languages,
                copyright:window.lambda.copyright,
                title: window.lambda.title,
                subTitle: window.lambda.subTitle,
                lambda:window.lambda,
                styleObj: {
                    backgroundImage: window.lambda.bg + ' !important'
                }
            }
        },

        computed: {
            lang() {
                return window.lambda.static_words[this.selectedLang]
            }
        },

        methods: {
            switchLanguage(val) {
                this.selectedLang = val;
                localStorage.setItem("lang", val);

            }
        }
    }
</script>

<style lang="scss">
    @import "./style.scss";
</style>

